<template>
  <v-container>

    <LoginView  style="max-width: 666px;" />
  
  </v-container>
</template>

<script setup>
import { inject } from 'vue'
import  LoginView from '@/components/objects/user/LoginView.vue'
import { CLEARMENT_TITLE, CLEARMENT_DESCRIPTION } from '@/constants/documentHead'

const updateDocumentHead = inject('updateDocumentHead')
updateDocumentHead?.(CLEARMENT_TITLE, CLEARMENT_DESCRIPTION)
  //import { reactive, ref } from "vue";
</script>
